"use strict";

angular
	.module('rmContact')
    .controller('ContactOverviewCtrl', require('./contact_overview_ctrl'))
    .controller('ContactFormCtrl', require('./contact_form_ctrl'));